import React from "react";
import { Button, Checkbox, FormControlLabel, Box } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import StatusTag from "./StatusTag";
import GenericMUITable from "../../../../components/GenericTable/index";

const PermissionTable = ({
  permissions,
  handleEditClick,
  handleToggleStatus,
  formatDateTime,
  currentPage,
  totalPages,
  totalRecords,
  itemsPerPage,
  handlePageChange,
  handleItemsPerPageChange,
}) => {
  // Define the columns for the permissions table
  const permissionFields = [
    { key: "name", label: "Name", align: "center" },
    { key: "description", label: "Description", align: "center" },
    {
      key: "status",
      label: "Status",
      width: "150px",
      align: "center",
      render: (permission) => (
        <StatusTag
          checked={permission.status === "ACTIVE"}
          onChange={() => handleToggleStatus(permission.name, permission.status)}
        />
      ),
    },
    {
      key: "createdAt",
      label: "Created At",
      align: "center",
      render: (permission) => formatDateTime(permission.createdAt),
    },
    {
      key: "updatedAt",
      label: "Updated At",
      align: "center",
      render: (permission) => formatDateTime(permission.updatedAt),
    },
    {
      key: "actions",
      label: "Actions",
      // Set a width for the actions column to prevent alignment issues
      width: "80px",
      align: "center",
      render: (permission) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Button
            size="small"
            onClick={() => handleEditClick(permission)}
            aria-label={`Edit ${permission.name}`}
            sx={{ minWidth: "auto", p: "4px" }}
          >
            <EditIcon sx={{ color: "#828282" }} />
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <GenericMUITable
      fields={permissionFields}
      data={permissions}
      rowKey="id"
      pagination={{
        currentPage,
        totalPages,
        totalRecords,
        itemsPerPage,
        onPageChange: handlePageChange,
        onItemsPerPageChange: handleItemsPerPageChange,
      }}
    />
  );
};

export default PermissionTable;
